module.exports = __webpack_public_path__ + "img/photo-4-2.7c864c3c.webp";